import React from 'react';
import Box from '@mui/material/Box';
import { keyframes } from '@mui/material/styles';

const floatUp = keyframes`
  0% { opacity: 0; transform: translateY(16px) scale(0.85); }
  18% { opacity: 1; transform: translateY(0) scale(1.08); }
  65% { opacity: 1; transform: translateY(-27px) scale(1); }
  100% { opacity: 0; transform: translateY(-58px) scale(0.95); }
`;

export default function PointAwardFloat({ amount = 1, icon = '⭐' }) {
  return (
    <Box aria-hidden="true" sx={{
      position: 'absolute', top: 58, right: 12, zIndex: 3, pointerEvents: 'none',
      px: 1.5, py: 0.65, borderRadius: 4, whiteSpace: 'nowrap',
      bgcolor: '#fff8d9', border: '2px solid #f6cf5a', boxShadow: '0 6px 18px rgba(146,64,14,0.22)',
      color: '#8a4b00', fontSize: 19, fontWeight: 900, lineHeight: 1.2,
      animation: `${floatUp} 1.35s ease-out forwards`,
      '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
    }}>
      {icon} +{amount} puan
    </Box>
  );
}
